import { useEffect } from 'react';

export default function useScrollReveal(ref, options = {}) {
  const { threshold = 0.1, stagger = 100 } = options;

  useEffect(() => {
    if (!ref?.current) return;

    const elements = Array.from(
      ref.current.querySelectorAll('.reveal, .reveal-left, .reveal-right')
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          const index = elements.indexOf(el); // 👈 correct order

          if (entry.isIntersecting) {
            el.style.transitionDelay = `${index * stagger}ms`;
            el.classList.add('visible');
          } else {
            el.classList.remove('visible'); // 👈 allows repeat
            el.style.transitionDelay = '0ms'; // reset
          }
        });
      },
      { threshold }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [ref, threshold, stagger]);
}